import { AppNavbar } from '@/components/app-navbar';
import { useAuth } from '@/hooks';
import { SpinnerScreen } from '@workspace/ui/components/spinner';
import { Navigate, Outlet } from 'react-router-dom';

export default function AppLayout() {
    const { data, isLoading, isError } = useAuth();

    if (isLoading) {
        return <SpinnerScreen text="Chargement..." />;
    }

    if (isError || !data?.user) {
        return <Navigate to="/auth/login" replace />;
    }

    return (
        <div className="min-h-screen flex flex-col">
            <AppNavbar userName={data.user.name} userRoles={data.user.roles} />
            <main className="flex-1 p-6">
                <Outlet />
            </main>
        </div>
    );
}
